// extracted by mini-css-extract-plugin
export var active = "y_bS";
export var menu = "y_R";
export var section = "y_b";
export var title = "y_w";